import { createSelector } from 'reselect'
import { find } from 'lodash'

const getAllLists = (state) => state.data
const getProps = (_state, props) => props

const selectUserRole = (state) => state.global.user.role
const selectAbilityInstance = (state) => state?.global?.ability
const selectRoles = (_, props) => props.roles
const selectAbilities = (_, props) => props.abilities

export const populateWithListData = createSelector(
  [getAllLists, getProps],
  (lists, { populate, data }) => {
    if (!data) return null
    return data.map((row) => {
      populate.forEach(({ key, list }) => {
        let id = row[key]
        if (lists[list] && id) {
          row[key] = find(lists[list], { id })
        }
      })
      return row
    })
  }
)

export const checkRoleAccess = createSelector(
  [selectUserRole, selectAbilityInstance, selectRoles, selectAbilities],
  (userRole, abilityInstance, roles, abilities) => {
    if (!userRole) return false

    const roleAccess = Array.isArray(roles) 
      ? roles.includes(userRole) 
      : userRole === roles
    
    if (roleAccess) {
      return true
    }

    if (abilities?.length) {
      return abilities.every(
        ({ i: action, this: subject }) => abilityInstance.can(action, subject)
      )
    }

    return false
  }
)